export const EXPIRY_PRESETS = [
  { value: "7", label: "7 днів" },
  { value: "14", label: "14 днів" },
  { value: "30", label: "30 днів" },
  { value: "custom", label: "Інша дата" },
];

export const DEFAULT_EXPIRY_PRESET = "30";
export const MAX_EXPIRY_DAYS = 30;

export function addDaysIso(days, from = new Date()) {
  const date = new Date(from.getTime());
  date.setDate(date.getDate() + Number(days));
  return date.toISOString();
}

export function toDatetimeLocalValue(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function expiresAtFromPreset(preset, customLocalValue, from = new Date()) {
  if (preset === "custom") {
    if (!customLocalValue) return null;
    const parsed = new Date(customLocalValue);
    if (Number.isNaN(parsed.getTime())) return null;
    return parsed.toISOString();
  }
  const days = Number(preset);
  if (!Number.isFinite(days) || days <= 0) {
    return addDaysIso(30, from);
  }
  return addDaysIso(days, from);
}

export function validateExpiryIso(iso, from = new Date()) {
  if (!iso) return "Вкажіть термін дії.";
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return "Некоректна дата завершення.";
  if (parsed.getTime() <= from.getTime()) {
    return "Термін дії має бути в майбутньому.";
  }
  const max = from.getTime() + MAX_EXPIRY_DAYS * 24 * 60 * 60 * 1000;
  if (parsed.getTime() > max) {
    return `Термін дії не може перевищувати ${MAX_EXPIRY_DAYS} днів.`;
  }
  return null;
}

export function inferExpiryPreset(iso, from = new Date()) {
  if (!iso) return DEFAULT_EXPIRY_PRESET;
  const target = new Date(iso).getTime();
  if (Number.isNaN(target)) return "custom";
  const dayMs = 24 * 60 * 60 * 1000;
  const deltaDays = Math.round((target - from.getTime()) / dayMs);
  if (deltaDays === 7 || deltaDays === 14 || deltaDays === 30) {
    return String(deltaDays);
  }
  return "custom";
}

export function resolveDraftExpiresAt(draft, from = new Date()) {
  if (draft && draft.expiry_dirty === false && draft.expires_at_original) {
    return draft.expires_at_original;
  }
  return expiresAtFromPreset(
    draft && draft.expiry_preset,
    draft && draft.custom_expires_at,
    from,
  );
}

export function buildExpiredRestorePayload(preset, customLocalValue, from = new Date()) {
  const expiresAt = expiresAtFromPreset(preset, customLocalValue, from);
  return {
    expires_at: expiresAt,
    error: validateExpiryIso(expiresAt, from),
  };
}
